import axios from "axios";
import { dataApi } from "@sitecore-jss/sitecore-jss-react";

import { getHostname } from "./util";
import config from "./temp/config";
import { getToken } from "./utils/cookies";
import utilsConfig from "./utils/config";
import { eventEnum } from "./utils/enum";

/**
 * Implements a data fetcher using Axios - replace with your favorite
 * SSR-capable HTTP or fetch library if you like. See HttpJsonFetcher<T> type
 * in sitecore-jss library for implementation details/notes.
 * @param {string} url The URL to request; may include query string
 * @param {any} data Optional data to POST with the request.
 */
function dataFetcher(url, data) {
  return axios({
    url,
    method: data ? "POST" : "GET",
    data,
    // note: axios needs to use `withCredentials: true` in order for Sitecore cookies to be included in CORS requests
    // which is necessary for analytics and such
    withCredentials: true,
  });
}

/**
 * Gets route data from Sitecore. This data is used to construct the component layout for a JSS route.
 * @param {string} route Route path to get data for (e.g. /about)
 * @param {string} language Language to get route data in (content language, e.g. 'en')
 */
export function getRouteData(route, language) {
  const fetchOptions = {
    layoutServiceConfig: { host: getHostname() },
    querystringParams: {
      sc_lang: language,
      sc_apikey: config.sitecoreApiKey,
      sc_site: config.scSite,
    },
    fetcher: dataFetcher,
  };
  const authentication = getToken();
  if (authentication) {
    fetchOptions.querystringParams = {
      ...fetchOptions.querystringParams,
      key: authentication?.accountId,
      token: authentication?.token,
    };
  }

  return dataApi.fetchRouteData(route, fetchOptions).catch((error) => {
    console.error("Route data fetch error", error);
    if (error?.response?.status === 401) {
      // 401 re login
      utilsConfig.eventEmitter.emitEvent(eventEnum.logout);
    }
  });
}
